import * as receiveMessage from './reducers/receive-message';
import * as sendMessage from './reducers/send-message';
import * as getChat from './reducers/get-chat';
import * as sendTyping from './reducers/send-typing';
import * as userTyping from './reducers/user-typing';
import * as disableChat from './reducers/disable-chat';
import * as getDisableChat from './reducers/get-disable-chat';
import * as deleteMessage from './reducers/delete-message';

import { simple } from 'src/utils/reducers';

export const chats = simple({
    TRADER_CHAT_RECEIVE_MESSAGE: receiveMessage.receive,
    TRADER_CHAT_SEND_MESSAGE_REQUEST: sendMessage.request,
    TRADER_CHAT_SEND_MESSAGE_ERROR: sendMessage.error,
    TRADER_CHAT_SEND_MESSAGE_FINISH: sendMessage.finish,

    TRADER_CHAT_TYPING_START: sendTyping.start,
    TRADER_CHAT_TYPING_STOP: sendTyping.stop,
    TRADER_CHAT_USER_TYPING_START: userTyping.start,
    TRADER_CHAT_USER_TYPING_STOP: userTyping.stop,

    TRADER_CHAT_GET_CHAT_REQUEST: getChat.request,
    TRADER_CHAT_GET_CHAT_ERROR: getChat.error,
    TRADER_CHAT_GET_CHAT_FINISH: getChat.finish,

    TRADER_CHAT_DISABLE_CHAT_REQUEST: disableChat.request,
    TRADER_CHAT_DISABLE_CHAT_ERROR: disableChat.error,
    TRADER_CHAT_DISABLE_CHAT_FINISH: disableChat.finish,

    TRADER_CHAT_GET_DISABLE_CHAT_REQUEST: getDisableChat.request,
    TRADER_CHAT_GET_DISABLE_CHAT_ERROR: getDisableChat.error,
    TRADER_CHAT_GET_DISABLE_CHAT_FINISH: getDisableChat.finish,

    TRADER_CHAT_DELETE_MESSAGE_REQUEST: deleteMessage.request,
    TRADER_CHAT_DELETE_MESSAGE_ERROR: deleteMessage.error,
    TRADER_CHAT_DELETE_MESSAGE_FINISH: deleteMessage.finish,
});
